import { Directive, ElementRef, Output, EventEmitter, HostListener, OnInit } from "@angular/core";

@Directive({
  selector: "[clickOutside]",
  standalone: false,
})
export class ClickOutsideDirective implements OnInit {
  constructor(private _elementRef: ElementRef) {}

  @Output()
  public clickOutside = new EventEmitter<MouseEvent>();

  private isReady = false;

  ngOnInit() {
    // Add a small delay before the directive starts listening
    setTimeout(() => {
      this.isReady = true;
    }, 100);
  }

  @HostListener("document:click", ["$event", "$event.target"])
  public onClick(event: MouseEvent, targetElement: HTMLElement): void {
    if (!targetElement || !this.isReady) {
      return;
    }

    const clickedInside = this._elementRef.nativeElement.contains(targetElement);
    if (!clickedInside) {
      this.clickOutside.emit(event);
    }
  }
}
